/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {UploadBasic, UploadPrefilledFileList, UploadRemoveFile, UploadSingleFile, UploadIsLoading, UploadErrorMessage, UploadAcceptedFormats} from 'Docs/uilib/components/upload/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Upload (default)"
    }), "\n", _jsx(UploadBasic, {}), "\n", _jsx(_components.h3, {
      children: "'useUpload' React Hook"
    }), "\n", _jsxs(_components.p, {
      children: ["By using the ", _jsx(_components.code, {
        children: "Upload.useUpload"
      }), " you can remove or add files or the status displayed in the component."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can also use the file blob in combination with the ", _jsx(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/API/File_API",
        children: "FileReader"
      }), " API."]
    }), "\n", _jsx(UploadRemoveFile, {}), "\n", _jsx(_components.h3, {
      children: "Upload single file/fixed amount of files"
    }), "\n", _jsx(UploadSingleFile, {}), "\n", _jsx(_components.h3, {
      children: "Upload loading state"
    }), "\n", _jsxs(_components.p, {
      children: ["When uploading the file you can set the loading state of the request using the ", _jsx(_components.code, {
        children: "Upload.useUpload"
      }), " hook and passing isLoading to the file that is being uploaded."]
    }), "\n", _jsx(UploadIsLoading, {}), "\n", _jsx(_components.h3, {
      children: "Upload error message"
    }), "\n", _jsxs(_components.p, {
      children: ["The only checks we do currently is for the file size and the file type. These errors are handled by the HTML element ´input´ so they aren't selectable. If you want any other error messages you can use the ", _jsx(_components.code, {
        children: "Upload.useUpload"
      }), " the same way as with the loading state."]
    }), "\n", _jsx(UploadErrorMessage, {}), "\n", _jsx(_components.h3, {
      children: "Upload specific accepted file formats"
    }), "\n", _jsx(_components.p, {
      children: "You can pass the file formats as a string array. This will restrict which files that can be selected."
    }), "\n", _jsx(UploadAcceptedFormats, {}), "\n", _jsx(_components.h3, {
      children: "Upload with prefilled error"
    }), "\n", _jsx(UploadPrefilledFileList, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
